/** @format */

import { useRef, useState } from 'react';
import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@clarix/ui';
import { getRoleColor } from '@clarix/utils';

interface RoleChipProps {
  roleName: string | null | undefined;
  className?: string;
}

export function RoleChip({ roleName, className }: RoleChipProps) {
  const label = roleName?.trim() ? roleName : 'No role';
  const textRef = useRef<HTMLSpanElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          onPointerEnter={() => {
            const el = textRef.current;
            if (!el) return;
            setOverflowing(el.scrollWidth - el.clientWidth > 1);
          }}
          className={cn(
            'inline-flex max-w-full items-center rounded-full px-2 py-0.5 text-lg font-medium leading-none',
            getRoleColor(roleName),
            className,
          )}
        >
          <span ref={textRef} className="truncate leading-none">
            {label}
          </span>
        </span>
      </TooltipTrigger>
      {/* A fully visible name needs no tip — it only repeats the chip and covers the row above. */}
      {overflowing ? (
        <TooltipContent side="top" sideOffset={4} className="w-max whitespace-nowrap leading-none">
          {label}
        </TooltipContent>
      ) : null}
    </Tooltip>
  );
}
